module.exports = __webpack_public_path__ + "img/fb-avatar.08f409ce.jpg";